

<div class="maintenancecls" *ngIf="showMaintenanceMode">
    <li style="list-style: none;">
        <span style="color: #f00;" *ngFor="let item of notification ">  
                {{item.message}}
        </span>
        <br />
    </li>
</div>
<div class="MaintenanceNotification" *ngIf="DisablePage">
    <div class="" >
        <span style="font-size: 50px;">:( Oops!!!</span><br><br>
        <span *ngFor="let item of notification ">
        {{item.message}}
       </span><br>
       <div class="col-md-12">
        <img src="xps/assets/img/Outage.gif" />
       </div>
    </div>
</div>
